import React from 'react'
import { useSelector } from 'react-redux'

import { CalcContainer } from 'aem-libs-react-ts/src/components/calculators'

import {
  AmountInputs,
  FollowUp,
  InputsContainer,
  ResultBoard,
  SavingsInputs,
} from './components'
import { CalcType } from './model/enums'
import { appSelector } from './store/selectors'

const AppContainer = () => {
  const { calcType } = useSelector(appSelector)

  return (
    <CalcContainer>
      <div className='cs-grid csas-norow csas-flex-sm csas-calc-loan--inner'>
        <InputsContainer>
          {calcType === CalcType.Amount && <AmountInputs />}
          {calcType === CalcType.Savings && <SavingsInputs />}
        </InputsContainer>
        <ResultBoard />
      </div>
      <FollowUp />
    </CalcContainer>
  )
}

export { AppContainer }
